

















































































































import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoPrice from '@/components/Atoms/co-price/coPrice.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';

interface EventTicket {
    ID?: string;
    Name: string;
    Description?: string;
    PriceInCents: number;
    TaxRateID?: string;
    Limit: number;
    CreatedAt?: number;
    UpdatedAt?: number;
    validUntil?: number;
    CancellationNotice?: number;
    CancellationFee?: number;
    TermsAndConditions?: string;
    AssociatedSessionID?: string;
    PaymentURL: string;
    Status?: number;
}

interface TaxRate {
    id: string;
    name: string;
    percentage: number;
    inclusive: true;
}
export default {
    name: 'CoTicketViewer',
    components: {
        CoModal,
        CoText,
        CoHeadline,
        CoCard,
        CoPill,
        CoDate,
        CoPrice,
        CoRoundButton,
    },
    props: {
        ticket: {
            type: Object as () => EventTicket,
            required: true,
        },
        taxRate: {
            type: Object as () => TaxRate,
            required: false,
        },
        currency: {
            type: String,
            default: 'EUR',
        },
        eventID: {
            type: String,
            default: null,
            required: true,
        },
        eventName: {
            type: String,
            default: null,
            required: true,
        },
        eventLocationAddress: {
            type: String,
            default: null,
            required: true,
        },
        eventStartDate: {
            type: [String, Number, Date],
            default: null,
            required: true,
        },
        eventEndDate: {
            type: [String, Number, Date],
            default: null,
            required: true,
        },
        ownerName: {
            type: String,
            default: null,
            required: true,
        },
    },
    data() {
        return {
            tocCollapsed: true,
            ppCollapsed: true,
            isPdfExporting: false,
        };
    },
    computed: {
        hasEventDates(): boolean {
            return Boolean(this.eventStartDate) && Boolean(this.eventEndDate);
        },
        isSameDay(): boolean {
            if (!this.hasEventDates) {
                return false;
            }
            const start = new Date(this.eventStartDate * 1000);
            const end = new Date(this.eventEndDate * 1000);
            return start.toDateString() === end.toDateString();
        },
        eventLocationName(): string {
            if (!this.eventLocationAddress || typeof this.eventLocationAddress !== 'string') {
                return '';
            }
            return this.eventLocationAddress.split(',')[0];
        },
        taxAmount(): number {
            if (this.taxRate && this.taxRate.percentage) {
                if (this.taxRate.inclusive) {
                    return (
                        (this.ticket.PriceInCents / 100) *
                        (this.taxRate.percentage / (100 + this.taxRate.percentage)) *
                        100
                    );
                }

                return (this.ticket.PriceInCents / 100) * (this.taxRate.percentage / 100) * 100;
            }
            return 0;
        },
        totalAmount(): number {
            if (this.taxRate && this.taxRate.percentage) {
                if (this.taxRate.inclusive) {
                    return this.ticket.PriceInCents / 100;
                }

                return (this.ticket.PriceInCents / 100) * (1 + this.taxRate.percentage / 100);
            }
            return this.ticket.PriceInCents / 100;
        },
    },
    mounted() {
        if (this.ticket) {
            this.show();
        }
    },
    methods: {
        show() {
            (this.$refs.ticket as any).show();
        },
    },
};
